import styled, { css } from 'styled-components';

const StyledContainer = styled.div<{
	$timerVisible?: boolean;
	$progressVisible?: boolean;
}>`
	position: absolute;
	top: 30px;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	user-select: none;
	pointer-events: none;
	transition: transform 0.3s ease;

	${(props) =>
		props.$timerVisible &&
		props.$progressVisible &&
		css`
			.timer {
				transform: translateX(-20px);
			}

			.progress {
				transform: translateX(20px);
			}
		`}
`;

const StyledDot = styled.div`
	width: 6px;
	height: 6px;
	margin-top: 12px;
	border-radius: 6px;
	background-color: rgba(255, 255, 255, 0.25);
	opacity: 0;
	transition:
		transform 0.5s ease,
		opacity 0.5s ease;

	&.dot-enter {
		opacity: 0;
		transform: scale(0);
	}

	&.dot-enter-active,
	&.dot-enter-done {
		opacity: 1;
		transform: scale(1);
	}

	&.dot-exit-active {
		opacity: 0;
		transform: scale(0);
	}
`;

export { StyledContainer, StyledDot };
